import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from 'react';
import classNames from 'classnames';
import isObject from 'lodash/isObject';
export var Slidebar = function Slidebar(props) {
  var _context, _classNames;

  var number = props.number,
      currentIndex = props.currentIndex,
      dotPosition = props.dotPosition,
      dotsClassName = props.dotsClassName,
      parentPrefixCls = props.parentPrefixCls,
      _onClick = props.onClick;
  var slideBarPrefixCls = "".concat(parentPrefixCls, "-slidebar");
  var slideClassName = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(slideBarPrefixCls), true), _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(slideBarPrefixCls, "-")).call(_context, dotPosition), true), _classNames));

  var renderDot = function renderDot() {
    var element = [];

    var _loop = function _loop(i) {
      var _classNames2, _classNames3;

      var dotClassName = isObject(dotsClassName) ? classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(dotsClassName.dotsClassName), true), _defineProperty(_classNames2, "".concat(dotsClassName.activeDotsClassName), i === currentIndex), _classNames2)) : classNames((_classNames3 = {}, _defineProperty(_classNames3, "".concat(slideBarPrefixCls, "-dot"), true), _defineProperty(_classNames3, "".concat(slideBarPrefixCls, "-dot-active"), i === currentIndex), _classNames3));
      var li = /*#__PURE__*/React.createElement("li", {
        key: i,
        className: dotClassName
      }, /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return _onClick(i);
        }
      }));
      element.push(li);
    };

    for (var i = 0; i <= number - 1; i++) {
      _loop(i);
    }

    return element;
  };

  return /*#__PURE__*/React.createElement("ul", {
    className: slideClassName
  }, renderDot());
};